module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp13_8017.49cfa04f.png";